import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { TeamworksWordmark } from "./TeamworksLogo";
import { useSettings } from "../providers/PlaylistProvider";
import { version } from "../../app.config";
import { useTranslation } from "react-i18next";
import { Spacer } from "./ViewComponents";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";

const makeStyles = (theme: ThemeOptions) =>
  StyleSheet.create({
    container: {
      flexDirection: "row",
      backgroundColor: theme.colors.grey2,
      alignItems: "center",
      justifyContent: "center",
      paddingVertical: theme.spacing.small,
      paddingHorizontal: theme.spacing.small,
    },
    wordmark: {
      width: theme.scaled(80),
      height: theme.scaled(20),
    },
    deviceDetails: {
      position: "absolute",
      right: theme.spacing.small,
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    text: {
      color: theme.colors.white,
      fontSize: theme.fontSize.detail,
    },
  });

export const ScreenFooter = () => {
  const settings = useSettings({ strict: false });
  const { t } = useTranslation("ScreenFooter");
  const theme = useTheme();
  const styles = makeStyles(theme);

  return (
    <View style={styles.container}>
      <TeamworksWordmark style={styles.wordmark} color={theme.colors.white} />
      <View style={styles.deviceDetails}>
        <Text style={[styles.text, { opacity: 0.6 }]} numberOfLines={1}>
          {settings.deviceName.length === 0
            ? t("Hardcoded")
            : settings.deviceName}
        </Text>
        <Spacer size="small" />
        <Text style={styles.text}>v{version}</Text>
      </View>
    </View>
  );
};
